import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css"

// Import Components
import Header from "./ui/Header.js"; // Import the updated Header component
import DevHome from "./site/Test_DevHome";
import StudentProfile from "./site/Student_Profile";
import FacultyDashboard from "./site/Faculty_Dashboard.js";
import SuccessPage from "./site/Success_Page";
import QuizEdit from "./ui/QuizForms/QuizEdit";
import AccountSuccess from "./site/Account_Success.js";
import ForgotPassword from "./ui/ForgotPassword.js";
import AddClasses from "./ui/AddClasses.js";
import AddClassSuccess from "./site/Add_ClassesSuccess.js";
import AdminCancel from "./site/AdminCancel.js";
import StudentDashboard from "./site/StudentDashboard.js";
import CancelAppointmentSite from "./site/CancelAppointmentSite";
import AddProctor from "./ui/AdminForms/AddProctor.js";
import AddProctorSuccess from "./ui/SuccessPages/AddProctorSuccess.js";
import EditProctorSuccess from "./ui/SuccessPages/EditProctorSuccess.js";
import ProctorAvailabilityDashboard from "./site/ProctorAvailabilityDashboard.js";
import SimpleLogin from "./site/SimpleLogin.js";
import FacultyApprovalDashboard from "./site/FacultyApprovalDashboard.js";
import RegisterAccount from "./ui/RegisterAccount.js";
import WaitingForApproval from "./site/WaitingForApproval.js";
import NavbarLayout from "./control/NavbarLayout.js";
import StudentAddCourse from "./site/StudentAddCourses.js";
import AddQuiz from "./ui/AdminForms/AddQuiz.js";
import AdministratorDashboard from "./site/Administrator_Dashboard.js";
import InstructorDashboard from "./site/Instructor_Dashboard.js";
import ProctorDashboard from "./site/Proctor_Dashboard.js";
import SignupAppointmentSite from "./site/SignupAppointmentSite.js";
import { AuthProvider } from "./firebase/auth";
import EditProctor from "./ui/AdminForms/EditProctor.js"; // adjust path if needed

function App() {
  return (
    <div className="App">
      <Router>
        <Header text="Georgia Gwinnett College" /> {/* Header with global styles */}
        <NavbarLayout>
          <Routes>
            <Route path="/" element={<SimpleLogin/>} />
            <Route path="/student/profile" element={<StudentProfile />} />
            <Route path="/faculty/dashboard" element={<FacultyDashboard />} />
            <Route path="/success" element={<SuccessPage />} />
            <Route path="/quizedit" element={<QuizEdit />} />
            <Route path="/account/success" element={<AccountSuccess />} />
            <Route path="/forgot/password" element={<ForgotPassword />} />
            <Route path="/add/classes" element={<AddClasses />} />
            <Route path="/class/success" element={<AddClassSuccess />} />
            <Route path="/admincancel" element={<AdminCancel />} />
            <Route path="/studentdashboard" element={<StudentDashboard />} />
            <Route path="/cancelAppointment" element={<CancelAppointmentSite />} />
            <Route path="/addproctor" element={<AddProctor />} />
            <Route path="/addproctorsuccess" element={<AddProctorSuccess />} />
            <Route path="/editproctorsuccess" element={<EditProctorSuccess />} />
            <Route path="/editproctor" element={<EditProctor />} />
            <Route path="/proctoravailabilitydashboard" element={<ProctorAvailabilityDashboard />} />
            <Route path="/simpleLogin" element={<SimpleLogin />} />
            <Route path="/facultyApprovalDashboard" element={<FacultyApprovalDashboard />} />
            <Route path="/registerAccount" element={<RegisterAccount />} />
            <Route path="/waitingForApproval" element={<WaitingForApproval />} />
            <Route path="/add/quiz" element={<AddQuiz />} />
            <Route path="/administratorDashboard" element={<AdministratorDashboard />} />
            <Route path="/instructorDashboard" element={<InstructorDashboard />} />
            <Route path="/proctorDashboard" element={<ProctorDashboard />} />
            <Route path="/signupAppointment" element={<SignupAppointmentSite />} />
            <Route path="/StudentAddCourse" element={<StudentAddCourse />} />
            <Route
              path="*"
              element={<h1 style={{ color: "white" }}>Error: Page Does Not Exist</h1>}
            />
          </Routes>
        </NavbarLayout>
      </Router>
    </div>
  );
}

export default App;

